import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import './map.css';
import "leaflet/dist/leaflet.css";
import { FaGripfire } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { fetchFires } from "../../Redux/mapSlice";

// Fix default marker issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const createIcon = (icon, color) =>
  new L.DivIcon({
    html: renderToStaticMarkup(<div style={{ fontSize: "1.5rem", color }}>{icon}</div>),
    className: "",
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

const wildfireIcon = createIcon(<FaGripfire />, "#e63946");

const CrisisMap = () => {
  const dispatch = useDispatch();
  const { fires, loading, error } = useSelector((state) => state.map);

  const filters = useSelector((state) => state.map.filters);

useEffect(() => {
dispatch(fetchFires(filters));
}, [dispatch, filters]);

  console.log("🔥 Fetched Fires:", fires);

  return (
    <div
      style={{
        height: "800px",
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        marginTop: "1rem",
      }}
    >
      {error && <p style={{ color: 'red' }}>❌ Error: {error}</p>}
      {loading && <p>⏳ Loading fire data...</p>}
      {!loading && fires.length === 0 && <p>⚠️ No fire data available.</p>}

      <MapContainer
        center={[20, 0]}
        zoom={2}
        minZoom={2}
        scrollWheelZoom={true}
        doubleClickZoom={true}
        dragging={true}
        zoomControl={true}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://osm.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {!loading && fires.filter((f) => f.latitude && f.longitude).map((fire, index) => (
          <Marker
            key={index}
            position={[fire.latitude, fire.longitude]}
            icon={wildfireIcon}
          >
            <Popup>
              <strong>🔥 Wildfire</strong><br />
              📅 Date: {fire.acq_date}<br />
              🕒 Time: {fire.acq_time}<br />
              📈 Confidence: {fire.confidence}<br />
              🔥 Brightness: {fire.brightness}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default CrisisMap;
